// The wristband colours (spec §6), in one place: a ticket type's colour lives in ticket_types.settings.color (hex);
// these eight are the standard row, a custom hex is allowed too. Opt-in: a ticket type has none until the organizer picks one.
// Geel is a deeper yellow so it stays visible on white.
export const TICKET_COLORS = [
  { key: 'red', hex: '#E5242B' },
  { key: 'blue', hex: '#2A119B' },
  { key: 'yellow', hex: '#F2C200' },
  { key: 'green', hex: '#1E8A4C' },
  { key: 'orange', hex: '#F07F00' },
  { key: 'purple', hex: '#7B2FBE' },
  { key: 'pink', hex: '#E8559A' },
  { key: 'black', hex: '#131313' },
] as const;

/** The wristband colour of this hex, if it is one of the eight (case-insensitive). */
export const wristbandOf = (hex: string | null | undefined) =>
  TICKET_COLORS.find((c) => c.hex.toLowerCase() === hex?.toLowerCase());

/** settings.color of a ticket type (or its settings), undefined when it has none. */
export const ticketColorOf = (tt: { settings?: unknown } | null | undefined) =>
  ((tt?.settings as { color?: unknown } | null)?.color as string | undefined) || undefined;

/**
 * The same colour for the dark ground: a colour too dark to read on it (Zwart, Blauw, a deep own
 * colour) is mixed toward white until it stands out; lighter ones stay as they are. Non-hex values
 * (currentColor, var(...)) pass through.
 */
export function onDarkGround(color: string | null | undefined): string | undefined {
  if (!color) return undefined;
  const m = /^#([0-9a-f]{6})$/i.exec(color.trim());
  if (!m) return color;
  const n = parseInt(m[1]!, 16);
  const rgb = [n >> 16, (n >> 8) & 255, n & 255];
  const lin = (c: number) => { const s = c / 255; return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; };
  const lum = 0.2126 * lin(rgb[0]!) + 0.7152 * lin(rgb[1]!) + 0.0722 * lin(rgb[2]!);
  if (lum >= 0.12) return color;
  // Mix with white: enough to clear ~3:1 against #1F1F1F for even the darkest ink
  const mix = lum < 0.02 ? 0.82 : 0.5;
  return '#' + rgb.map(c => Math.round(c + (255 - c) * mix).toString(16).padStart(2, '0')).join('');
}
